import { Box, MessageStripe } from "prism-react";
import type { MessageStripeVariant } from "prism-react";
import React from "react";

export interface DevtoolMessageProps {
  children: React.ReactNode;
  variant: MessageStripeVariant;
  onDismiss?: () => void;

  actions: Array<{
    loading?: boolean;
    actionText: string;
    onAction: () => void;
  }>;
}

export const DevtoolMessage: React.FC<DevtoolMessageProps> = ({
  actions,
  children,
  variant,
  onDismiss,
}) => (
  <Box
    css={{
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      zIndex: "$menu",
    }}
  >
    <MessageStripe
      corners="straight"
      justify="space-between"
      onDismiss={onDismiss}
      variant={variant}
    >
      {children}

      {actions.length > 1 ? (
        <MessageStripe.MultiActions
          loading={actions[0]!.loading}
          onClick={actions[0]!.onAction}
          options={actions.slice(1).map(({ actionText, onAction }) => (
            <MessageStripe.MultiActionsItem onSelect={onAction}>
              {actionText}
            </MessageStripe.MultiActionsItem>
          ))}
          variant={variant}
        >
          {actions[0]!.actionText}
        </MessageStripe.MultiActions>
      ) : (
        actions.map(({ loading, actionText, onAction }) => (
          <MessageStripe.Action
            key={actionText}
            loading={loading}
            onClick={onAction}
            variant="trial"
          >
            {actionText}
          </MessageStripe.Action>
        ))
      )}
    </MessageStripe>
  </Box>
);
